import { capitalize } from 'lodash';
import { useIntl } from 'react-intl';

import type { MultiFlightEntityType } from 'sonata-static-storage/lib/common/common.types';

type Props = {
  entityName: string;
  entityParentName?: string;
  entityType: MultiFlightEntityType;
};

export function EntityInformationalHeader({ entityName, entityParentName, entityType }: Props): JSX.Element {
  const { formatMessage } = useIntl();

  return (
    <div className="entityInformationalHeader" id="informationalHeader">
      <div className="entityInformationalHeader__entityName">
        <span className="entityInformationalHeader__entityNameTitle">
          {formatMessage({
            defaultMessage: `${capitalize(entityType)}: `,
            id: `pacingStatusModal.header.title.${entityType}`
          })}
        </span>
        <span className="entityInformationalHeader__entitySubtitle">{entityName}</span>
      </div>
      {!!entityParentName && (
        <div className="entityInformationalHeader__parentEntity">
          <span className="entityInformationalHeader__parentEntityTitle">{entityParentName}</span>
        </div>
      )}
    </div>
  );
}
